import { render } from "./NavBarLink.vue?vue&type=template&id=73620938"
import script from "./NavBarLink.vue?vue&type=script&lang=js"
export * from "./NavBarLink.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__